import React, { useState } from 'react';
import { WalletIcon } from 'lucide-react';
interface WalletBalanceProps {
  availableBalance: number;
  onBalanceApplied: (amount: number) => void;
  onBalanceRemoved: () => void;
}
export function WalletBalance({
  availableBalance,
  onBalanceApplied,
  onBalanceRemoved
}: WalletBalanceProps) {
  const [isEnabled, setIsEnabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const handleToggle = () => {
    if (isEnabled) {
      setIsEnabled(false);
      onBalanceRemoved();
    } else {
      setIsEnabled(true);
      onBalanceApplied(availableBalance);
    }
  };
  return <>
      <div className="bg-white rounded-lg shadow-sm p-4 md:p-6" data-id="element-2126" data-mp="273fgc324d9ih">
        <div className="flex items-center justify-between" data-id="element-2127" data-mp="2265iq04ktrjk">
          <div className="flex items-center gap-3" data-id="element-2128" data-mp="227qcvomzb8gw">
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-2129" data-mp="vptr6hw9f7wy">
              <WalletIcon className="w-5 h-5 text-green-600" data-id="element-2130" data-mp="qq7dk7cirpnm" />
            </div>
            <div data-id="element-2131" data-mp="5edottkb2szs">
              <h3 className="text-sm md:text-base font-bold text-gray-900" data-id="element-2132" data-mp="5fyjrkaj8dy6">
                Use Wallet Balance
              </h3>
              <p className="text-xs md:text-sm text-gray-600" data-id="element-2133" data-mp="9fpica6avyd9">
                Available:{' '}
                <span className="font-bold text-green-600" data-id="element-2134" data-mp="3rlls8qbo0pt6">
                  SAR {availableBalance.toFixed(2)}
                </span>
              </p>
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer" data-id="element-2135" data-mp="3hvimrqncxjdy">
            <input type="checkbox" checked={isEnabled} onChange={handleToggle} className="sr-only peer" data-id="element-2136" data-mp="3mnadq2afdr4m" />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600" data-id="element-2137" data-mp="3duqf31u4vmjs"></div>
          </label>
        </div>
        {isEnabled && <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg" data-id="element-2138" data-mp="2fzwc8wcxews9">
            <p className="text-xs md:text-sm text-green-800" data-id="element-2139" data-mp="2b2mfswr4dkux">
              ✓ SAR {availableBalance.toFixed(2)} will be deducted from your
              wallet
            </p>
          </div>}
      </div>
      {/* Wallet Balance Modal */}
      {modalOpen && <>
          {/* Desktop Modal */}
          <div className="hidden md:block fixed inset-0 z-[60] overflow-y-auto" data-id="element-2140" data-mp="2ypm8lnwc7qma">
            {/* ... existing modal code ... */}
          </div>
          {/* Mobile Bottom Sheet */}
          <div className="md:hidden fixed inset-0 z-[60]" data-id="element-2141" data-mp="2oszncy03mxjq">
            {/* ... existing bottom sheet code ... */}
          </div>
        </>}
    </>;
}